import { render, staticRenderFns } from "./HealthCrossIcon.vue?vue&type=template&id=41783012&scoped=true&"
import script from "./HealthCrossIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HealthCrossIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41783012",
  null
  
)

export default component.exports